import _ from "lodash";
import React from "react";

import images from "@/utils/images";
import { SUPPORT_NUMBER } from "@/constants/aptihealth";

import "../styles.scss";

const FamilyMembersWidget = (props) => {
  const { profile } = props;

  const associated_wards = _.get(profile, "enriched_associated_wards", []);
  const associated_guardians = _.get(profile, "enriched_associated_guardians", []);
  const familyMembers = [...associated_wards, ...associated_guardians];

  const displayAddChild = () => {
    return associated_wards.length > 0;
  };

  const renderFamilyMembers = (familyMembers) => {
    return familyMembers.map((familyMember, i) => {
      let borderClass = "border-top";

      if (i === 0) {
        borderClass = "";
      }

      return (
        <li
          className={`d-flex justify-content-between py-3 ${borderClass}`}
          key={familyMember.id || `${familyMember.first_name}-${familyMember.last_name}-${i}`}
        >
          <div className="d-flex">
            <img alt="Icon" className="pr-4" src={images("./icons/family-member-icon.svg")} />
            <div data-private="true">
              <div className="fs-18 txt-navy tw:font-bold">
                {familyMember.first_name} {familyMember.last_name}
              </div>
              <div className="fs-16 txt-gry">{familyMember.email}</div>
            </div>
          </div>

          <div className="d-md-block d-none">
            <div className="fs-16 txt-navy tw:font-bold">For Support Contact</div>
            <div className="fs-16 txt-gry">{SUPPORT_NUMBER}</div>
          </div>
        </li>
      );
    });
  };

  return (
    <div className="mb-3 pb-md-3 pb-0">
      <div className="d-flex justify-content-between pb-2">
        <div className="fs-22 txt-gry tw:font-bold">Family Members</div>
        {displayAddChild() && (
          <div
            className="d-flex pointer align-items-center"
            onClick={() => props.history.push("/app/teens-and-kids/program-details")}
          >
            <img
              alt="Icon"
              src={images("./icons/plus-circle-icon-2.png")}
              style={{ height: "16px", width: "16px" }}
            />

            <div className="txt-gry fs-16 d-flex align-items-center ml-1 tw:font-bold">
              Add Child
            </div>
          </div>
        )}
      </div>

      <ul className="px-4 dashboard-widget-card">{renderFamilyMembers(familyMembers)}</ul>
    </div>
  );
};

export default FamilyMembersWidget;
